<style>
  :host {
    display: inline-block;
    vertical-align: middle;
  }
</style>
<span class="px-2 py-1" [ngClass]="styleClass">
  <ng-content></ng-content>
</span>
